import {Button} from 'antd';
import cn from 'classnames';
import React, {useEffect, FC} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

import {ReactComponent as ErrorAlert} from 'shared/assets/error-alert.svg';
import {DEFAULT_THEME} from 'shared/constants/layout';
import {URL_FORBIDDEN, URL_LOGIN, URL_VERIFY_2FA_CODE} from 'shared/constants/urls';
import {useAppSelector} from 'store/config/hooks';
import {authSliceActions, logout, selectAuthError} from 'store/slices/auth-slice';

import './forbidden-form.less';

interface IForbiddenFormProps {
    lastLocation?: string;
}

export const ForbiddenForm:FC<IForbiddenFormProps> = ({lastLocation}: IForbiddenFormProps) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const isForbiddenPage = history.location.pathname === URL_FORBIDDEN;
    const isForbidden = useAppSelector(selectAuthError)?.code === 403;
    const need2FA = history.location.state?.need2FA;

    useEffect(() => () => {
        if (isForbidden) dispatch(authSliceActions.resetError());
    }, [lastLocation]);

    return (
        <div className="forbidden-form">
            {isForbiddenPage && (
                <div className="forbidden-form__header">
                    <img
                        className={cn({
                            'forbidden-form__partner-logo': (
                                process.env.REACT_APP_THEME !== DEFAULT_THEME
                            ),
                        })}
                        src={`${process.env.PUBLIC_URL}/logos/${process.env.REACT_APP_THEME}-light.svg`}
                        alt="Витрина налогового мониторинга."
                    />
                    <h1>
                        Витрина налогового мониторинга
                    </h1>
                </div>
            )}
            <div className="forbidden-form__verbose-error">
                {isForbiddenPage && (
                    <ErrorAlert className="forbidden-form__verbose-error__logo" />
                )}
                <div className="forbidden-form__verbose-error__message">
                    Недостаточно прав для просмотра страницы
                </div>
            </div>
            <div
                className="forbidden-form__button-container"
            >
                {isForbiddenPage ? (
                    <>
                        <Button
                            type="primary"
                            block
                            onClick={() => {
                                if (need2FA) {
                                    history.push(URL_VERIFY_2FA_CODE)
                                } else {
                                    history.go(-1)
                                }
                            }}
                        >
                            Назад
                        </Button>
                        <Button
                            type="primary"
                            block
                            onClick={() => {
                                dispatch(logout());
                                history.push(URL_LOGIN);
                            }}
                        >
                            Выйти
                        </Button>
                    </>
                ) : (
                    <>
                        <Button
                            type="primary"
                            onClick={() => history.go()}
                        >
                            Попробовать ещё раз
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                if (lastLocation) {
                                    history.push(lastLocation);
                                } else {
                                    history.go(-1);
                                }
                                dispatch(authSliceActions.resetError());
                            }}
                        >
                            Вернуться назад
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};
